import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SelectField } from '@/components/select-field';
import { ESDEC_ZONES_BY_COUNTRY } from '../esdec-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icons } from '@/assets';
import { EsdecWeatherZonesPlaceholder } from './esdec-weather-zones-card';

export const EsdecSnowzoneTypeInput = observer(function EsdecSnowzoneTypeInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const intl = useIntl();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  const snowzoneOptions = ESDEC_ZONES_BY_COUNTRY.sweden.snowzone.map((snowzone) => ({
    label: snowzone,
    value: snowzone
  }));

  return (
    <SelectField
      isDisabled={surfaceEsdec.isRoofFinalized}
      label={intl.formatMessage({
        defaultMessage: 'Snowzone Type',
        id: 'SLIxGD'
      })}
      placeholder={
        <EsdecWeatherZonesPlaceholder
          icon={<Icons.Snow />}
          text={<FormattedMessage defaultMessage="Select Snow Zone" id="kX3Hci" />}
        />
      }
      name="snowzone"
      options={snowzoneOptions}
      onChange={(value) => {
        if (value) {
          surfaceEsdec.updateSnowzone(value.value);
        }
      }}
      value={snowzoneOptions.find((snowzoneOption) => snowzoneOption.value === surfaceEsdec.snowzone)}
    />
  );
});
